var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "userTab" } },
    [
      _c("div", { staticClass: "modal-header manage_header" }, [
        _c("div", { staticStyle: { width: "100%" } }, [
          _c(
            "a",
            {
              staticClass: "text-uppercase text-muted pt-1",
              attrs: { href: "javascript:void(0);" },
              on: { click: _vm.hide }
            },
            [
              _c("img", {
                staticClass: "back_icon mr-2",
                attrs: { src: require("@/assets/manager/back_button_icon.png") }
              }),
              _vm._v("Back")
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close float-right",
              attrs: { type: "button" },
              on: { click: _vm.hide }
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body user-info" }, [
        _c("div", { staticClass: "row mb-4" }, [
          _c("div", { staticClass: "col-9 pl-3" }, [
            _c("div", { staticClass: "h5 mr-2" }, [
              _vm._v(_vm._s(_vm.display_firstName + " " + _vm.display_lastName))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "h5 mr-2" }, [
              _vm._v(_vm._s(_vm.display_email))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "h6 mr-2" }, [
              _vm._v(_vm._s(_vm.accountName))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-3 pl-3" }, [
            _c(
              "a",
              {
                staticClass: "link_btn",
                staticStyle: {
                  "background-color": "#00acee",
                  padding: "5px 25px",
                  "border-radius": "15px",
                  color: "#FFF !important"
                },
                on: { click: _vm.updateUser }
              },
              [_vm._v("Save")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "loading_show"
          },
          [_c("div", { staticClass: "spinner-border text-danger" })]
        ),
        _vm._v(" "),
        _vm.resetLinkSuccessMsg
          ? _c("div", { staticClass: "text-green" }, [
              _vm._v(_vm._s(_vm.resetLinkSuccessMsg))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.statusUpdateSuccessMsg
          ? _c("div", { staticClass: "text-green" }, [
              _vm._v(_vm._s(_vm.statusUpdateSuccessMsg))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row edit_row" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm.isUpdateMsg
              ? _c("p", { staticClass: "text-green" }, [
                  _vm._v("User details are updated successfully")
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row edit_row" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.firstName,
                  expression: "firstName"
                }
              ],
              ref: "first_name",
              staticClass: "col-12 col-sm-12 input-height-35 form-control",
              attrs: {
                type: "first_name",
                name: "first_name",
                "data-vv-as": "First name",
                maxlength: "180"
              },
              domProps: { value: _vm.firstName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.firstName = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.verrors.has("first_name"),
                    expression: "verrors.has('first_name')"
                  }
                ],
                staticClass: "validate-warning-msg"
              },
              [_vm._v(_vm._s(_vm.verrors.first("first_name")))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.lastName,
                  expression: "lastName"
                }
              ],
              ref: "last_name",
              staticClass: "col-12 col-sm-12 input-height-35 form-control",
              attrs: {
                type: "last_name",
                name: "last_name",
                "data-vv-as": "Last name",
                maxlength: "180"
              },
              domProps: { value: _vm.lastName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.lastName = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.verrors.has("last_name"),
                    expression: "verrors.has('last_name')"
                  }
                ],
                staticClass: "validate-warning-msg"
              },
              [_vm._v(_vm._s(_vm.verrors.first("last_name")))]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "row edit_row",
            staticStyle: { "margin-top": "10px" }
          },
          [
            _c("div", { staticClass: "col-12" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email"
                  }
                ],
                ref: "email",
                staticClass: "col-12 col-sm-12 input-height-35 form-control",
                attrs: {
                  type: "text",
                  name: "email",
                  "data-vv-as": "Email",
                  maxlength: "180",
                  disabled: "true"
                },
                domProps: { value: _vm.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  }
                }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "row edit_row",
            staticStyle: { "margin-top": "10px" }
          },
          [
            _c("div", { staticClass: "col-12" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phoneNo,
                    expression: "phoneNo"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { rules: { regex: _vm.phoneNumberValidRegex() } },
                    expression: "{ rules: { regex: phoneNumberValidRegex() } }"
                  }
                ],
                ref: "phone_number",
                staticClass: "col-12 col-sm-12 input-height-35 form-control",
                attrs: {
                  type: "text",
                  name: "phone_number",
                  "data-vv-as": "Phone number",
                  maxlength: "20"
                },
                domProps: { value: _vm.phoneNo },
                on: {
                  keyup: function($event) {
                    return _vm.phoneNumberFormat()
                  },
                  blur: function($event) {
                    return _vm.phoneNumberFormat()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.phoneNo = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.verrors.has("phone_number"),
                      expression: "verrors.has('phone_number')"
                    }
                  ],
                  staticClass: "validate-warning-msg"
                },
                [_vm._v(_vm._s(_vm.verrors.first("phone_number")))]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row edit_row" }, [
          _c("div", { staticClass: "col-2 text-center p-0" }, [
            _c("label", { staticClass: "input_label", attrs: { for: "" } }, [
              _vm._v("Password")
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "a",
                {
                  staticClass: "link_btn",
                  on: { click: _vm.openResetLinkModal }
                },
                [_vm._v(" Reset")]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.isCanAddTransfer == true && _vm.status == "Active"
            ? _c("div", { staticClass: "col-2 text-center" }, [
                _c(
                  "label",
                  { staticClass: "input_label", attrs: { for: "" } },
                  [_vm._v("Add/Transfer")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "offcanvas_link",
                    on: { click: _vm.openTransferLinkModal }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/enterprise/Move_User_16x16.png")
                      }
                    })
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.userType == "mentee" || _vm.userType == "apprentice"
            ? _c("div", { staticClass: "col-2 text-center" }, [
                _c(
                  "label",
                  { staticClass: "input_label", attrs: { for: "" } },
                  [_vm._v("Status")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm.status == "Active"
                    ? _c(
                        "a",
                        {
                          class: "status_link " + _vm.getFontColor(_vm.status),
                          on: {
                            click: function($event) {
                              return _vm.openStatusModal(_vm.status)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.formatStatus(_vm.status)))]
                      )
                    : _vm._e()
                ])
              ])
            : _c("div", { staticClass: "col-2 text-center" }, [
                _c(
                  "label",
                  { staticClass: "input_label", attrs: { for: "" } },
                  [_vm._v("Status")]
                ),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "a",
                    {
                      class: "status_link " + _vm.getFontColor(_vm.status),
                      on: {
                        click: function($event) {
                          return _vm.openStatusModal(_vm.status)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.formatStatus(_vm.status)))]
                  )
                ])
              ])
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "hr_line_2" }),
        _vm._v(" "),
        _vm.userType == "mentee" || _vm.userType == "apprentice"
          ? _c(
              "div",
              {
                staticClass: "pad-15 mb-5",
                staticStyle: { "padding-left": "0 !important" }
              },
              [
                _vm.editPathwayList.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "col-12 p-0",
                        staticStyle: { "margin-top": "10px" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-12 p-0 bold",
                            attrs: { for: "roles" }
                          },
                          [_vm._v("Assign Pathway: ")]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.editPathwayList, function(
                          pathway,
                          key,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              staticClass:
                                "col-12 p-0 col-sm-12 tasklist-assign-wrapper"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "custom-control custom-radio"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.editpathwaySelected,
                                          expression: "editpathwaySelected"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        name: "pathway_assigned",
                                        type: "radio",
                                        id: "edit_mentee_pathway_" + pathway.id
                                      },
                                      domProps: {
                                        value: pathway.id,
                                        checked: _vm._q(
                                          _vm.editpathwaySelected,
                                          pathway.id
                                        )
                                      },
                                      on: {
                                        change: [
                                          function($event) {
                                            _vm.editpathwaySelected = pathway.id
                                          },
                                          _vm.getPathwaySteps
                                        ]
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for:
                                            "edit_mentee_pathway_" + pathway.id
                                        }
                                      },
                                      [_vm._v(_vm._s(pathway.pathwayName))]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.verrors.has("pathway_assigned")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Pathway is required")]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.editPathwayList.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "col-12 p-0",
                        staticStyle: { "margin-top": "10px" }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-4" }, [
                            _c("div", { staticClass: "chkboxwrapper" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "custom-control custom-checkbox"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editShowFutureSteps,
                                        expression: "editShowFutureSteps"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      name: "future steps",
                                      value: "1",
                                      type: "checkbox",
                                      id: "edit_mentee_future_steps"
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.editShowFutureSteps
                                      )
                                        ? _vm._i(_vm.editShowFutureSteps, "1") >
                                          -1
                                        : _vm.editShowFutureSteps
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.editShowFutureSteps,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "1",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.editShowFutureSteps = $$a.concat(
                                                [$$v]
                                              ))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.editShowFutureSteps = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.editShowFutureSteps = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "edit_mentee_future_steps" }
                                    },
                                    [_vm._v("Show future steps")]
                                  )
                                ]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.pathwaySteps, function(step, key, index) {
                          return _c(
                            "div",
                            {
                              staticClass:
                                "col-12 p-0 col-sm-12 tasklist-assign-wrapper"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "custom-control custom-radio"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.editStepSelected,
                                          expression: "editStepSelected"
                                        }
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        name: "Begin at step",
                                        type: "radio",
                                        id: "edit_mentee_step_" + step.id
                                      },
                                      domProps: {
                                        value: step.id,
                                        checked: _vm._q(
                                          _vm.editStepSelected,
                                          step.id
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.editStepSelected = step.id
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for: "edit_mentee_step_" + step.id
                                        }
                                      },
                                      [_vm._v(_vm._s(step.stepTitle))]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
            )
          : _c("div", { staticClass: "pad-15" }, [
              _c("div", { staticClass: "row edit_row" }, [
                _c(
                  "div",
                  { staticClass: "assigned_heading_1 font-weight-bold" },
                  [_vm._v("Assessments")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "assigned_heading_2 font-weight-bold text-center"
                  },
                  [_vm._v("Results")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "assigned_heading_3 font-weight-bold text-center"
                  },
                  [_vm._v("Access")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm.assignedAssessmentsCount > 0
                  ? _c(
                      "div",
                      { staticClass: "row_item_readonly" },
                      _vm._l(_vm.assignedAssessments, function(item, acindex) {
                        return _c(
                          "div",
                          { key: acindex, staticClass: "row_data_border" },
                          [
                            _c("div", { staticClass: "assigned_heading_1" }, [
                              _vm._v(_vm._s(item.title))
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "assigned_heading_2 text-center" },
                              [
                                item.complete_attempt_id
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "link_btn_highlight",
                                        attrs: {
                                          target: "_blank",
                                          to:
                                            "/assessment-report/" +
                                            item.complete_attempt_id
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                            View\n                            "
                                        )
                                      ]
                                    )
                                  : _c("span", [_vm._v("n/a")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "assigned_heading_3 text-center" },
                              [
                                _c("div", { staticClass: "chkboxwrapper" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.assessmentsSelected,
                                            expression: "assessmentsSelected"
                                          }
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          name: "Assign Assessments",
                                          id: "assign_assessment_" + acindex
                                        },
                                        domProps: {
                                          value: item.id,
                                          checked: Array.isArray(
                                            _vm.assessmentsSelected
                                          )
                                            ? _vm._i(
                                                _vm.assessmentsSelected,
                                                item.id
                                              ) > -1
                                            : _vm.assessmentsSelected
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.getAssessmentSelected(
                                              $event
                                            )
                                          },
                                          change: function($event) {
                                            var $$a = _vm.assessmentsSelected,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = item.id,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.assessmentsSelected = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.assessmentsSelected = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.assessmentsSelected = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for: "assign_assessment_" + acindex
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" })
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.assignedAssessmentsCount === 0
                  ? _c("div", [
                      _c("div", { staticClass: "col-12 text-red mt-2" }, [
                        _vm._v("No Assessment Found.")
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row edit_row" }, [
                _c("div", { staticClass: "courses_head_1 font-weight-bold" }, [
                  _vm._v("Courses")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "courses_head_2 font-weight-bold" }, [
                  _vm._v("Final Exam Score")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "courses_head_3 font-weight-bold" }, [
                  _vm._v("Certificate")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "courses_head_4 font-weight-bold text-center"
                  },
                  [_vm._v("Access")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm.assignedCoursesCount > 0
                  ? _c(
                      "div",
                      { staticClass: "row_item_readonly" },
                      _vm._l(_vm.assignedCourses, function(item, lacindex) {
                        return _c(
                          "div",
                          { key: lacindex, staticClass: "row_data_border" },
                          [
                            _c("div", { staticClass: "courses_item_1" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(item.title) +
                                  "\n                            "
                              ),
                              item.score
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        ref: "show_icon_" + lacindex,
                                        refInFor: true,
                                        staticClass: "show_icon",
                                        on: {
                                          click: function($event) {
                                            return _vm.getCourseModuleInfo(
                                              item.lmsUserId,
                                              item.lmsCourseId,
                                              "course_user_results_modules_" +
                                                lacindex,
                                              lacindex
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/enterprise/down_arrow_image16x16.png"),
                                            width: "16",
                                            height: "16"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        ref: "hide_icon_" + lacindex,
                                        refInFor: true,
                                        staticClass: "hide_icon",
                                        on: {
                                          click: function($event) {
                                            return _vm.hideCourseModuleInfo(
                                              item.lmsUserId,
                                              item.lmsCourseId,
                                              "course_user_results_modules_" +
                                                lacindex,
                                              lacindex
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/enterprise/up_arrow_image16x16.png"),
                                            width: "16",
                                            height: "16"
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "courses_item_2 text-center" },
                              [
                                item.score
                                  ? _c("span", [
                                      _vm._v(_vm._s(item.score) + "%")
                                    ])
                                  : _c("span", [_vm._v("n/a")])
                              ]
                            ),
                            _vm._v(" "),
                            item.certification_download_link
                              ? _c(
                                  "div",
                                  { staticClass: "courses_item_3 text-center" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "link_btn_highlight",
                                        attrs: {
                                          href:
                                            item.certification_download_link,
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v("View")]
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "courses_item_3 text-center" },
                                  [_vm._v("n/a")]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "courses_item_4 text-center" },
                              [
                                _c("div", { staticClass: "chkboxwrapper" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.courseSelected,
                                            expression: "courseSelected"
                                          }
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          name: "Assign Course",
                                          id: "assign_course_" + lacindex
                                        },
                                        domProps: {
                                          value: item.id,
                                          checked: Array.isArray(
                                            _vm.courseSelected
                                          )
                                            ? _vm._i(
                                                _vm.courseSelected,
                                                item.id
                                              ) > -1
                                            : _vm.courseSelected
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.getCourseSelected($event)
                                          },
                                          change: function($event) {
                                            var $$a = _vm.courseSelected,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = item.id,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.courseSelected = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.courseSelected = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.courseSelected = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for: "assign_course_" + lacindex
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                            _vm._v(" "),
                            item.score
                              ? _c(
                                  "div",
                                  [
                                    _c("CourseUserResultsModules", {
                                      ref:
                                        "course_user_results_modules_" +
                                        lacindex,
                                      refInFor: true
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" })
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.assignedCoursesCount === 0
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 text-red mt-2",
                          staticStyle: { "margin-bottom": "15px" }
                        },
                        [_vm._v("No Courses Found.")]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.userType === "mentee" || _vm.userType === "apprentice"
                ? _c("div", { staticClass: "row edit_row" }, [
                    _c(
                      "div",
                      { staticClass: "assigned_form_h1 font-weight-bold" },
                      [_vm._v("Task Lists")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "assigned_form_h2 font-weight-bold text-center"
                      },
                      [_vm._v("Access")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.assignedTaskListsCount > 0
                      ? _c(
                          "div",
                          { staticClass: "row_item_readonly" },
                          _vm._l(_vm.assignedTaskLists, function(
                            item,
                            acindex
                          ) {
                            return _c(
                              "div",
                              { key: acindex, staticClass: "row_data_border" },
                              [
                                _c("div", { staticClass: "forms_item_1" }, [
                                  _vm._v(_vm._s(item.name))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "forms_item_2 text-center" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "chkboxwrapper" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-control custom-checkbox"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.taskListsSelected,
                                                  expression:
                                                    "taskListsSelected"
                                                }
                                              ],
                                              staticClass:
                                                "custom-control-input",
                                              attrs: {
                                                type: "checkbox",
                                                name: "Assign TaskList",
                                                id: "assign_tasklist_" + acindex
                                              },
                                              domProps: {
                                                value: item.id,
                                                checked: Array.isArray(
                                                  _vm.taskListsSelected
                                                )
                                                  ? _vm._i(
                                                      _vm.taskListsSelected,
                                                      item.id
                                                    ) > -1
                                                  : _vm.taskListsSelected
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.getTasklistSelected(
                                                    $event
                                                  )
                                                },
                                                change: function($event) {
                                                  var $$a =
                                                      _vm.taskListsSelected,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = item.id,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.taskListsSelected = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.taskListsSelected = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.taskListsSelected = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              staticClass:
                                                "custom-control-label",
                                              attrs: {
                                                for:
                                                  "assign_tasklist_" + acindex
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" })
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.assignedTaskListsCount === 0
                      ? _c("div", [
                          _c("div", { staticClass: "col-12 text-red mt-2" }, [
                            _vm._v("No Task Lists Found.")
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }),
      _vm._v(" "),
      _c("userResetLinkModal", {
        ref: "user_reset_modal_popup",
        attrs: { isModalVisible: _vm.isUserResetLinkModal },
        on: { close: _vm.closeResetLinkModal }
      }),
      _vm._v(" "),
      _c("UserActivateModal", {
        ref: "user_activate_modal",
        attrs: {
          isModalVisible: _vm.isUserActivateModal,
          page_from: "user_detail"
        },
        on: { close: _vm.closeUserActivateModal }
      }),
      _vm._v(" "),
      _c("UserInactivateModal", {
        ref: "user_inactivate_modal",
        attrs: {
          isModalVisible: _vm.isUserInactivateModal,
          page_from: "user_detail"
        },
        on: { close: _vm.closeUserInactivateModal }
      }),
      _vm._v(" "),
      _c("AddTransferLinkModal", {
        ref: "add_transfer_modal_popup",
        attrs: {
          isModalVisible: _vm.isTransferLinkModal,
          accountName: _vm.accountName,
          accountId: _vm.accountId
        },
        on: { close: _vm.closeTransferLinkModal }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "input_label", attrs: { for: "" } }, [
      _vm._v("User Information "),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-8 p-0 d-inline" }, [
      _c("label", { staticClass: "col-12 bold", attrs: { for: "roles" } }, [
        _vm._v("Begin at step: ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f40b61d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f40b61d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/view_user_detail_manage.vue
// module id = null
// module chunks = 